import { api } from "./../api";
import { ApiPaths } from "./../api/paths";
import { IMigrateGuestRequest, ISignInRequestData, ISignUpRequestData } from "./../../store/auth/types";
import {
    GetGuestTokensResponse,
    SignInRequestResponse,
    SignUpRequestResponse,
    RefreshTokenRequestResponse,
    ConfirmUserRequestResponse,
    MigrateGuestToUserResponse,
} from "./auth.service.d";

export class AuthService {
    /**
     * Sign in request
     *
     * @param  no_params
     */
    static async getGuestTokens(): Promise<GetGuestTokensResponse> {
        return api.post(ApiPaths.SIGN_IN);
    }

    /**
     * Sign in request
     *
     * @param  {ISignInData} signInData
     */
    static async signIn(signInData: ISignInRequestData): Promise<SignInRequestResponse> {
        return api.post(ApiPaths.SIGN_IN, signInData);
    }

    /**
     * Sign up request
     *
     * @param  {ISignUpData} signUpData
     */
    static async signUp(signUpData: ISignUpRequestData): Promise<SignUpRequestResponse> {
        return api.post(ApiPaths.SIGN_UP, signUpData);
    }

    /**
     * Migrate guest to user Request
     *
     * @param  {IMigrateGuest} userId
     */
    static async migrateGuest(data: IMigrateGuestRequest): Promise<MigrateGuestToUserResponse> {
        return api.post(ApiPaths.MIGRATE_USER, { data: data.userId });
    }

    /**
     * Get Current User Request
     *
     * @param  no_params
     */
    static async getCurrentUser(): Promise<MigrateGuestToUserResponse> {
        return api.get(ApiPaths.CURRENT_USER);
    }

    /**
     * refresh Token
     *
     * @param  {string} refresh_token
     */
    static async refreshToken(refresh_token: string): Promise<RefreshTokenRequestResponse> {
        return api.post(ApiPaths.REFRESH_TOKEN, { refresh_token });
    }

    /**
     * refresh Token
     *
     * @param  {string} code
     */
    static async confirmUser(code: string | null): Promise<ConfirmUserRequestResponse> {
        return api.post(ApiPaths.CONFIRM_USER, { code });
    }
}
